import React from "react";
import { Input } from "antd";
import { Search } from "lucide-react";
import type { InputProps } from "antd";
import styles from "./SearchInput.module.scss";

interface SearchInputProps extends Omit<InputProps, "prefix" | "bordered"> {
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({ placeholder = "Tìm kiếm...", ...props }) => {
  return (
    <Input
      {...props}
      placeholder={placeholder}
      prefix={<Search size={14} className={styles.searchIcon} />}
      bordered={false}
      className={styles.searchInput}
      allowClear
    />
  );
};

export default SearchInput;
